import { render, staticRenderFns } from "./trailerListing.vue?vue&type=template&id=b1095b50&scoped=true&"
import script from "./trailerListing.vue?vue&type=script&lang=js&"
export * from "./trailerListing.vue?vue&type=script&lang=js&"
import style0 from "./trailerListing.vue?vue&type=style&index=0&id=b1095b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1095b50",
  null
  
)

export default component.exports